<div class="upload-container">
    @switch (useCase) {
        @case (UploadUseCase.NormalUpload) {
            <div>
                <h2 class="upload-heading">Upload Media</h2>
            </div>
        }
        @case (UploadUseCase.ReplaceMediaContent) {
            <div>
                <div class="tooltip-container flex align-items-center gap-2">
                    <h2 class="upload-heading">Replace Media Content</h2>
                    <i class="pi pi-info-circle tooltip-icon"
                       pTooltip="Modifies the content of the media while retaining the original filename."></i>
                </div>
            </div>
        }
        @case (UploadUseCase.UploadForSpecificCaseWithExistingMediaView) {
            <div>
                <h2 class="upload-heading">Upload Specific Media</h2>
            </div>
        }
    }

    <div class="flex flex-col gap-3 my-4">
        <!-- File input -->
        <div class="file-input">
            <p-button
                    label="Choose File"
                    icon="pi pi-upload"
                    class="w-full"
                    severity="secondary"
                    [disabled]="uploadInProgress"
                    (click)="fileInput.click()"
            ></p-button>
            <input
                #fileInput
                id="file-upload"
                type="file"
                (change)="onFileChange($event)"
                multiple
                hidden
            />
        </div>

        <!-- Selected file name -->
        @if (hasSelectedFiles()) {
            <p-message
                    severity="info"
                    text="Selected File: {{ selectedFiles![0].name }}"
            ></p-message>
        }

        <!-- Media notes -->
        @if (useCase === UploadUseCase.NormalUpload && hasSelectedFiles()) {
            <p-ifta-label>
        <textarea
                [(ngModel)]="mediaNotes"
                class="w-full"
                id="media-notes"
                pTextarea
                placeholder="Add notes for the Media"
                rows="3"
                style="resize: none"
        ></textarea>
                <label for="media-notes">Media Notes</label>
            </p-ifta-label>
        }
    </div>


    <!-- Actions -->
    <div class="actions flex gap-3 mt-4">
        @if (selectedFiles && selectedFiles.length > 0 && !uploadInProgress && !uploadCompleted) {
            <p-button
                    isMaintainer
                    (click)="startUpload()"
                    icon="pi pi-cloud-upload"
                    label="Start Upload"
                    severity="primary"
            ></p-button>
        }

        @if (uploadInProgress && uploadId) {
            <p-button
                    (click)="cancelUpload()"
                    icon="pi pi-times"
                    label="Cancel Upload"
                    severity="danger"
            ></p-button>
        }
    </div>

    <!-- Progress bar -->
    @if (uploadInProgress && progress > 0 && progress < 100) {
    <p-progressBar
            [value]="progress"
            [showValue]="true"
            class="mt-3"
    ></p-progressBar>
    }
</div>
